<div *ngFor="let snack of snacks; let i = index;">
   
    <div @state
    [ngClass]="{'top-right': positionTopRight}"
    class="snackbar-wrap position{{i}} {{snack.type}}">
        <div id="snackIcon{{i}}" class="snack-icon" >
            <span class="icon-size">
                <span *ngIf="snack.type === 'info'">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 -8.74228e-07C15.523 -3.91392e-07 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 3.91392e-07 15.523 8.74228e-07 10C1.35706e-06 4.477 4.477 -1.35706e-06 10 -8.74228e-07ZM11 7L11 5L9 5L9 7L11 7ZM11 15L11 9L9 9L9 15L11 15Z" fill="#3099E6"/>
                    </svg>    
                </span>
                <span *ngIf="snack.type === 'error'">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 8.586L7.172 5.757L5.757 7.172L8.586 10L5.757 12.828L7.172 14.243L10 11.414L12.828 14.243L14.243 12.828L11.414 10L14.243 7.172L12.828 5.757L10 8.586Z" fill="#E80000"/>
                    </svg>
                </span>
                <span *ngIf="snack.type === 'warning'">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9 13V15H11V13H9ZM9 5V11H11V5H9Z" fill="#E2E630"/>
                    </svg>
                </span>
                <span *ngIf="snack.type === 'success'">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="#07754D"/>
                    </svg> 
                </span>
                <span *ngIf="snack.type === 'success_custom'">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="#FFF"/>
                    </svg> 
                </span>
            </span>
       </div>
        <div class="snack-body">
            <p id="snackText{{i}}" class="snackbar-text text{{snack.type}}">{{snack.message}}</p>
        </div>
        <div id="snackCloseBtn{{i}}" class="snack-close">
            <lib-svg class="close-icon" [icon]="'close_x_ico'" (click)="closeSnack(snack)"></lib-svg>
        </div>
    </div>
</div>